<template>
	<nta-dialog
		:show="compProps.show"
		:title="symbolsStore.GUILabel('b85c3da1-9363-4c91-a2c2-efc544bf6e02') + ': ' + term"
		max-title-width="80%"
		:symbol-lang="domainStore.languagePreference"
		height="auto"
		width="35em"
		@close="cancel()"
	>
		<template #default>
			<v-container v-if="!datatype">
				<v-alert
					type="error"
					:title="symbolsStore.GUILabel('8051f8be-9067-4a43-9efa-33eba2137ca5')"
					:text="symbolsStore.GUILabel('46b4285c-f399-4053-8986-35770be2e2d6')"
				>
				</v-alert>
			</v-container>
			<v-container v-else-if="datatype.id === 'reference'">
				<v-alert type="info" :title="symbolsStore.GUILabel('606a9eeb-b0c5-4abb-a0fd-32ad8843d9a5')">
					<template #text>
						<p>{{ symbolsStore.GUILabel("56a21191-cd05-4a99-9e66-4ac40df2abdd") }}</p>
						<p>{{ symbolsStore.GUILabel("cc653303-fbf1-415f-8691-df7f9f0bc1b4") }}</p>
					</template></v-alert
				>
			</v-container>
			<v-container v-else>
				<datatype-input
					:datatype="isArray ? arraytype : datatype"
					:is-array="isArray"
					:attribute-id="instanceAttribute?.id || ''"
					:label="term"
					:autofocus="true"
					:instance-task="undefined"
					show-unknown-button="true"
					style="width: 100%"
					@set="onSet"
				/>
			</v-container>
		</template>
	</nta-dialog>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useGraphStore } from "../../../store/graph";
import { useAlternisStore } from "../../../store/alternis/index";
import { useSymbolsStore } from "../../../store/symbols";
import { useDomainStore } from "../../../store/domain";
import DatatypeInput from "./DatatypeInput.vue";

const graphStore = useGraphStore();
const alternisStore = useAlternisStore();
const symbolsStore = useSymbolsStore();
const domainStore = useDomainStore();

const emits = defineEmits(["done", "set"]);
const compProps = defineProps<{
	show: boolean;
	attributeId: string;
}>();

const instanceAttribute = computed(() => {
	return graphStore.instance.attribute.byId(compProps.attributeId);
});
const conceptAttribute = computed(() => {
	return graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
});
const datatype = computed(() => {
	return graphStore.descriptor.datatype.byId(conceptAttribute.value?.datatype || "");
});
const arraytype = computed(() => {
	if (datatype.value?.id !== "array") return;
	return graphStore.descriptor.datatype.byId(conceptAttribute.value?.arraytype || "");
});
const isArray = computed(() => datatype.value?.id === "array");
const term = computed(() => {
	return symbolsStore.term({
		id: conceptAttribute.value?.refersTo,
		terminology: conceptAttribute.value?.terminology,
	});
});

function cancel() {
	emits("done");
}
function onSet(value: any) {
	let v = "undefined";
	if (value !== undefined && value !== null && value !== "") v = value;
	graphStore.instance.attribute.update(instanceAttribute.value?.id || "", v).then(() => emits("set"));
}

watch(
	() => compProps.show,
	(show) => {
		if (!show) alternisStore.clickedHighlightWord = "";
	},
	{ immediate: true },
);
</script>
